import React, {useState} from 'react';
import {Button, DatePicker, Form, Select, Table, Tag} from "antd";
import dayjs from "dayjs";
import toast from "react-hot-toast";
import {useQueryClient} from "@tanstack/react-query";
import {internalApi} from "../../../common/axios";
import {SEGMENT_EVENTS_KEY} from "./useEventSegment";

const rangeText = (min, max, prefix = '') => Number(max) === 0 ? '제한 없음' : `${prefix}${min} ~ ${prefix}${max}`;

// 개인화 테이블 [추가하기]: 그룹의 이벤트 전체를 같은 기간으로 개인화 관리(event_segment_master)에 편성한다.
const SegmentRegisterModal = ({segment, eventTable, handleClose}) => {
    const queryClient = useQueryClient();
    const [begin, setBegin] = useState(dayjs().hour(9).startOf('hour'));
    const [end, setEnd] = useState(dayjs().add(1, 'day').hour(8).endOf('hour'));
    const [onOff, setOnOff] = useState(0);
    const [saving, setSaving] = useState(false);

    const handleSave = async () => {
        if (!begin.isBefore(end)) return toast.error('시작일이 종료일보다 늦습니다.');
        setSaving(true);
        try {
            const res = await internalApi.post('events/segment/register', {data: {segmentIdx: segment.seq, begin: begin.unix(), end: end.unix(), onOff}});
            toast.success(res.data.message);
            queryClient.invalidateQueries({queryKey: [SEGMENT_EVENTS_KEY]});
            handleClose();
        } catch {
            // 실패 사유는 axios 인터셉터가 표시
        } finally {
            setSaving(false);
        }
    };

    const columns = [
        {title: '이벤트', dataIndex: 'typeIndex', key: 'typeIndex', render: (typeIndex) => `${eventTable?.[typeIndex]?.nameText || ''}(${typeIndex})`},
        {title: '평균 결제 금액(달러)', key: 'avrPayment', render: (_, r) => rangeText(r.minAvrPayment, r.maxAvrPayment, '$')},
        {title: '레벨', key: 'level', render: (_, r) => rangeText(r.minLevel, r.maxLevel)},
    ];

    return (
        <div>
            <Form layout="inline" style={{marginBottom: 8}}>
                <Form.Item label="메모" style={{width: '100%', marginBottom: 8}}>
                    <Tag color="purple">[{segment.seq}] {segment.memo || '-'}</Tag>
                </Form.Item>
                <Form.Item label="시작 시간" style={{marginBottom: 8}}>
                    <DatePicker value={begin} showTime={{format: 'HH:mm'}} format="YYYY-MM-DD HH:mm" size="small" allowClear={false}
                                onChange={date => date && setBegin(date)}/>
                </Form.Item>
                <Form.Item label="종료 시간" style={{marginBottom: 8}}>
                    <DatePicker value={end} showTime={{format: 'HH:mm:ss'}} format="YYYY-MM-DD HH:mm:ss" size="small" allowClear={false}
                                onChange={date => date && setEnd(date)}/>
                </Form.Item>
                <Form.Item label="On/Off" style={{marginBottom: 8}}>
                    <Select value={onOff} onChange={setOnOff} size="small" style={{width: 80}}
                            options={[{value: 1, label: 'On'}, {value: 0, label: 'Off'}]}/>
                </Form.Item>
            </Form>

            <div style={{border: '2px solid #1e4d7b', borderRadius: 8, padding: 12}}>
                <div style={{fontWeight: 'bold', marginBottom: 8}}>등록될 이벤트 ({segment.items.length}개)</div>
                <Table columns={columns} dataSource={segment.items.map(item => ({...item, key: item.seq}))} pagination={false} size="small"/>
                <div style={{marginTop: 8, color: '#888', fontSize: 12}}>
                    운영 타입·트리거 등 이벤트별 세부 설정은 등록 후 개인화 관리에서 이벤트를 눌러 편집하세요.
                </div>
            </div>

            <div style={{marginTop: 16, display: 'flex', gap: 8, justifyContent: 'flex-end'}}>
                <Button onClick={handleClose}>취소</Button>
                <Button type="primary" loading={saving} onClick={handleSave}>등록</Button>
            </div>
        </div>
    );
};

export default SegmentRegisterModal;
